import React from "react";
import ReactAnimatedWeather from "react-animated-weather";

export default function WeatherIcon(props) {
  const codeMapping = {
    "01d": "CLEAR_DAY",
    "01n": "CLEAR_NIGHT",
    "02d": "PARTLY_CLOUDY_DAY",
    "02n": "PARTLY_CLOUDY_NIGHT",
    "03d": "PARTLY_CLOUDY_DAY",
    "03n": "PARTLY_CLOUDY_NIGHT",
    "04d": "CLOUDY",
    "04n": "CLOUDY",
    "09d": "RAIN",
    "09n": "RAIN",
    "10d": "RAIN",
    "10n": "RAIN",
    "11d": "RAIN",
    "11n": "RAIN",
    "13d": "SNOW",
    "13n": "SNOW",
    "50d": "FOG",
    "50n": "FOG",
  };

  const colorMapping = {
    "01d": "#FFD700", // Clear day - gold
    "01n": "#4169E1", // Clear night - royal blue
    "02d": "#FFA500", // Partly cloudy day - orange
    "02n": "#708090", // Partly cloudy night - slate gray
    "03d": "#708090", // Partly cloudy day - slate gray
    "03n": "#708090", // Partly cloudy night - slate gray
    "04d": "#696969", // Cloudy - dim gray
    "04n": "#696969", // Cloudy - dim gray
    "09d": "#1E90FF", // Rain - dodger blue
    "09n": "#1E90FF", // Rain - dodger blue
    "10d": "#1E90FF", // Rain - dodger blue
    "10n": "#1E90FF", // Rain - dodger blue
    "11d": "#4169E1", // Rain - royal blue
    "11n": "#4169E1", // Rain - royal blue
    "13d": "#F0F8FF", // Snow - alice blue
    "13n": "#F0F8FF", // Snow - alice blue
    "50d": "#D3D3D3", // Fog - light gray
    "50n": "#D3D3D3", // Fog - light gray
  };

  return (
    <ReactAnimatedWeather
      icon={codeMapping[props.code]}
      color={colorMapping[props.code] || "#1e1e1e"}
      size={props.size}
      animate={true}
    />
  );
}
